import './App.css';
import React, {useEffect, useState} from "react";
import State from "./State";
import PageService from "./Pages/PageService";
import ClipLoader from "react-spinners/ClipLoader";
import ReactMarkdown from 'react-markdown'

function App({jsonServer}) {

    const [state] = useState(new State(useState(0)));

    const service = new PageService(jsonServer, state);

    useEffect(() => {
        service.fetchPage('förstasidan');
    }, []);

    if (state.errorMsg) {
        return (<span className="errorMessage">{state.errorMsg}</span>);
    }

    const snippets = !state.loading && state.page != null ? state.page.snippets : [];
    const sponsorBlock = !state.loading && state.page != null && state.page.blocks.length > 1 ? state.page.blocks[1] : null;

    const logo = (filename) => {
        return process.env.PUBLIC_URL + '/media/logotyper/' + filename;
    }
    const bgUrl = 'url(' + process.env.PUBLIC_URL + '/media/nyloparbild.jpg)';
    return (
        <div className="wrapper">
            <div className="hero" style={{'backgroundImage': bgUrl}}>
                <h1><span>Välkomna till Kanallöpet!</span></h1>
            </div>

            <div className="content">
                <div className="intro">
                    <h2>Kanallöpet är ett arrangemang för tävlingslöpare, motionärer och
                        familjer i vacker svensk natur.</h2>

                    <p className="lead">Loppet går längs Göta Kanal mellan Ljungsbro och
                        Borensberg &frac12;-mara, tävling och motion, 10 och 5 km motion.</p>

                    <div className="row">
                        <div className="info col-sm-6">
                            {state.loading ? (<div><ClipLoader loading={state.loading} size={150}/></div>) : ''}
                            {snippets.map(s =>
                                (
                                    <>
                                        <h3>{s.headline}</h3>
                                        <ReactMarkdown>{s.content}</ReactMarkdown>
                                    </>

                                ))
                            }
                        </div>
                        <div className="promoters col-sm-6">
                            <h3>Arrangerande föreningar</h3>

                            <ul>
                                <li><a href="http://www.borensbergsif.com/" target="_blank"><img alt="Borensberg IF"
                                                                                                 src={logo('bif.gif')}/>
                                    <span>Borensberg IF</span> </a></li>
                                <li><a href="https://www.vretasomk.se/" target="_blank"><img alt="Vreta SoMK"
                                                                                             src={logo('vreta.png')}/>
                                    <span>Vreta SoMK</span> </a></li>
                                <li><a href="https://www.okroxen.se/moderklubbarna/ok-skogsstrovarnaolstorp/"
                                       target="_blank"><img
                                    alt="OK Skogsströvarna" src={logo('oks.jpg')}/>
                                    <span>OK Skogsströvarna</span> </a></li>

                            </ul>
                        </div>
                    </div>

                    <div className="sponsors">
                        {
                            !sponsorBlock ? '' : (
                                <>
                                    <h4>{sponsorBlock.headline}</h4>
                                    <ul>{
                                        sponsorBlock.textSnippets.map(s => {
                                            const textParts = s.content.split("\n").map(c => c.trim());

                                            return (
                                                <>
                                                    <li key={s.id}><a
                                                        href={textParts[0]}
                                                        target="_blank"><img alt={s.headline} title={s.headline} src={logo(textParts[1])}/></a>
                                                    </li>
                                                </>)
                                        })
                                    }
                                    </ul>
                                </>
                            )

                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
